import * as types from '../mutation-types'
const state = {
	products: []
}

const actions = {
	fetchAllProducts ({ commit }) {
		return window.axios.get('/products').then((response) => {
			commit(types.STORE_PRODUCTS, response.data)
			return response.data
		})
	},

	fetchProductBySlug ({ commit }, { slug }) {
		return window.axios.get(`/products/${slug}`)
	}
}

const mutations = {
	[types.STORE_PRODUCTS] (state, products) {
		state.products = products;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}